import { useState, useEffect } from 'react'
import { get } from '../../utils/api'
import { IconUser, IconMail, IconPhone } from '@tabler/icons-react'

const ROLE_COLORS = {
  corporate_admin: 'bg-purple-lt',
  vp: 'bg-blue-lt',
  regional_director: 'bg-teal-lt',
}

export default function CorporateTeam() {
  const [team, setTeam] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    get('/corporate/team').then(setTeam).catch(console.error).finally(() => setLoading(false))
  }, [])

  if (loading) return <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>

  return (
    <div>
      <div className="mb-4">
        <h2 className="mb-1">Corporate Team</h2>
        <div className="text-secondary">{team.length} corporate users</div>
      </div>

      <div className="row g-3">
        {team.map(u => (
          <div key={u.id} className="col-sm-6 col-lg-4">
            <div className="card h-100">
              <div className="card-body">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <span className="avatar avatar-lg rounded-circle bg-primary">
                    {u.name?.split(' ').map(n => n[0]).join('').toUpperCase()}
                  </span>
                  <div>
                    <h3 className="mb-0">{u.name}</h3>
                    {u.title && <div className="text-secondary" style={{ fontSize: '0.85rem' }}>{u.title}</div>}
                  </div>
                </div>
                <div className="mb-3">
                  <span className={`badge ${ROLE_COLORS[u.role] || 'bg-secondary-lt'}`}>
                    {u.role.replace(/_/g, ' ')}
                  </span>
                  {u.region_name && <span className="badge bg-blue-lt ms-1">{u.region_name}</span>}
                  <span className={`badge ms-1 ${u.is_active ? 'bg-green-lt' : 'bg-red-lt'}`}>
                    {u.is_active ? 'Active' : 'Inactive'}
                  </span>
                </div>
                <div className="d-flex flex-column gap-1" style={{ fontSize: '0.85rem' }}>
                  {u.email && (
                    <div className="d-flex align-items-center gap-2 text-secondary">
                      <IconMail size={14} />{u.email}
                    </div>
                  )}
                  {u.phone && (
                    <div className="d-flex align-items-center gap-2 text-secondary">
                      <IconPhone size={14} />{u.phone}
                    </div>
                  )}
                  {u.last_login && (
                    <div className="text-secondary" style={{ fontSize: '0.75rem' }}>
                      Last login: {new Date(u.last_login).toLocaleDateString()}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
        {!team.length && (
          <div className="col-12 text-center text-secondary py-5">No corporate team members found</div>
        )}
      </div>
    </div>
  )
}
